import React from "react";
import { Link } from "gatsby";

const serviceVariants = [
  { slug: "emergency-dentist", label: "Emergency Dentist" },
  { slug: "cdbs-dentist", label: "CDBS Dentist" }
];

// Whitelist: only suburbs that actually have dedicated service-location pages.
// This prevents broken links being generated for suburbs without those pages.
const SUBURB_AVAILABLE_VARIANTS: Record<string, string[]> = {
  broadmeadows: ["emergency-dentist", "cdbs-dentist"],
  campbellfield: ["emergency-dentist", "cdbs-dentist"],
  craigieburn: ["emergency-dentist", "cdbs-dentist"],
  "gladstone-park": ["cdbs-dentist"], // no emergency-dentist page exists
  glenroy: ["emergency-dentist", "cdbs-dentist"],
  greenvale: ["emergency-dentist", "cdbs-dentist"],
  hadfield: ["emergency-dentist", "cdbs-dentist"],
  "meadow-heights": ["emergency-dentist", "cdbs-dentist"],
  mickleham: ["emergency-dentist", "cdbs-dentist"],
  "roxburgh-park": ["emergency-dentist", "cdbs-dentist"],
};

interface RelatedServiceLinksProps {
  suburbName: string;
  suburbSlug: string;
  currentVariant?: string;
  className?: string;
}

const RelatedServiceLinks = ({
  suburbName,
  suburbSlug,
  currentVariant,
  className = "bg-background",
}: RelatedServiceLinksProps) => {
  const availableForSuburb = SUBURB_AVAILABLE_VARIANTS[suburbSlug] ?? [];

  const filtered = serviceVariants
    .filter((v) => availableForSuburb.includes(v.slug))
    .filter((v) => v.slug !== currentVariant);

  // Nothing to show - suburb has no service pages or all variants are current page
  if (filtered.length === 0) return null;

  return (
    <section className={`py-16 ${className}`}>
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <h3 className="text-2xl md:text-3xl font-bold text-neutral-800 mb-6 text-center">
            Dental Services Near {suburbName}
          </h3>
          <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {filtered.map((variant) => (
              <li key={variant.slug} className="bg-white border border-primary/10 rounded-2xl shadow-soft">
                <Link
                  to={`/${suburbSlug}-${variant.slug}`}
                  className="block p-5 text-center text-neutral-800 font-semibold hover:text-primary transition-gentle"
                >
                  {variant.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default RelatedServiceLinks;
export { serviceVariants };
